<template>
  <div class="summary-slider">
    <button v-if="!isSummaryOpen" class=" summary-slider__btn" @click="toggleSummary">
      <span class="summary-slider__chevron">
        <img :src="chevron" class="" />
      </span>
      <span>Order Summary</span>
      <span class="summary-slider__cart-icon-wrapper">
        <img :src="cartIcon" class=" summary-slider__cart-icon" />
      </span>
      <span v-if="item">${{totalAmount}}</span>
      <span v-else>$--</span>
    </button>
    <section v-if="isSummaryOpen" class="summary-slider__close">
      <span @click="toggleSummary" class="summary-slider__chevron summary-slider__chevron--close">
        <img :src="chevron" />
      </span>
      <button @click="goToService" :disabled="!requiredFieldsMet" class="btn btn--secondary btn--small">
        <span>Continue</span>
        <img :src="iconArrowRight">
      </button>
    </section>
    <section
      class="summary-slider__wrapper"
      v-if="isSummaryOpen">
      <OrderSummary @address-edit="this.isSummaryOpen = false"/>
      <footer class="summary-slider__footer">
        <button @click="toggleSummary" class="summary-slider__hide-btn">Hide Summary</button>
        <button id="orderSummarySliderBtn" @click="goToService" :disabled="!requiredFieldsMet" class="btn btn--secondary btn--small">
          <span>Continue</span>
          <img :src="iconArrowRight">
        </button>
      </footer>
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OrderSummary from './OrderSummary.vue'

import { timestamp, isGoogleEventsReady, getClientID } from '@/utilities.js'
import config from '@/config'
const { cdn } = config
export default {
  components: {
    OrderSummary
  },
  data: () => {
    return {
      cartIcon: `${cdn}icons-cart.svg`,
      chevron: `${cdn}chevron-icon.svg`,
      iconArrowRight: `${cdn}icons-arrow-right.svg`,
      isSummaryOpen: false
    }
  },
  methods: {
    goToService () {
      const time = timestamp()
      const buttonText = document.getElementById('orderSummarySliderBtn').innerText
      this.isSummaryOpen = false
      switch (this.$route.path) {
        case '/cart' :
          if (isGoogleEventsReady()) {
            window.gtag('event', 'Ecommerce - ContinueToPlacement', {
              event_category: 'Ecommerce',
              event_label: `${time}~${window.location.href}~${buttonText}`,
              send_to: process.env.VUE_APP_UA_ID
            })

            window.gtag('event', 'Ecommerce - ContinueToPlacement', {
              event_category: 'Ecommerce',
              button_text: buttonText,
              timestamp: time,
              bd_client_id: getClientID(),
              send_to: process.env.VUE_APP_GA4_ID
            })
          }
          this.$router.push('/cart/service')
          break
        case '/cart/service' :
          if (isGoogleEventsReady()) {
            window.gtag('event', 'Ecommerce - ContinueToPayment', {
              event_category: 'Ecommerce',
              event_label: `${time}~${window.location.href}~${buttonText}`,
              send_to: process.env.VUE_APP_UA_ID
            })

            window.gtag('event', 'Ecommerce - ContinueToPayment', {
              event_category: 'Ecommerce',
              button_text: buttonText,
              timestamp: time,
              bd_client_id: getClientID(),
              send_to: process.env.VUE_APP_GA4_ID
            })
          }
          this.$router.push('/cart/payment')
          break
      }
    },
    toggleSummary () {
      this.isSummaryOpen = !this.isSummaryOpen
    }
  },
  computed: {
    ...mapState('cart', ['item']),
    ...mapState('customer', ['serviceAddress']),
    ...mapGetters({
      isContinueDisabled: 'dumpster/isContinueDisabled',
      totalAmount: 'cart/totalAmount'
    }),
    requiredFieldsMet: {
      get () {
        if (this.$route.path === '/cart') {
          return !this.isContinueDisabled
        } else if (this.$route.path === '/cart/payment') {
          return false
        } else {
          return this.$store.state.customer.requiredFieldsMet
        }
      }
    }
  }
}
</script>
